import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import QuestionPageLayout from '../../components/QuestionPageLayout';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const CurrentlyEmployedPage = ({
  initialCurrentlyEmployed,
  dispatchAddPageData,
  dispatchWizardNav,
}) => {
  const handleSubmit = currentlyEmployed => {
    analytics.sendEvent('Click - Next', 'currently-employed');

    const payload = payloadFactory.createAddPageDataPayload('currentlyEmployed', currentlyEmployed);
    dispatchAddPageData(payload);

    if (!currentlyEmployed) {
      const resetCurrentSalaryPayload = payloadFactory.createResetPageObjectPayLoad(
        'currentSalary',
        'currentSalary',
      );
      dispatchAddPageData(resetCurrentSalaryPayload);

      const resetEmployerPayload = payloadFactory.createResetPageDataPayload('employer');
      dispatchAddPageData(resetEmployerPayload);

      const resetEmployerCountryPayload = payloadFactory.createResetPageDataPayload(
        'employerCountry',
        'employerOfficeCountryCode',
      );
      dispatchAddPageData(resetEmployerCountryPayload);

      const resetEmploymentDatesPayload = payloadFactory.createResetPageObjectPayLoad(
        'employmentDates',
        'employmentDates',
      );
      dispatchAddPageData(resetEmploymentDatesPayload);
    }

    const resetFullTimeEmploymentDatesPayload = payloadFactory.createResetPageObjectPayLoad(
      'fullTimeEmploymentDates',
      'fullTimeEmploymentDates',
    );
    dispatchAddPageData(resetFullTimeEmploymentDatesPayload);

    const resetFullTimeEmployedDuringCoursePayload = payloadFactory.createResetPageDataPayload(
      'fullTimeEmployedDuringCourse',
      'fullTimeEmployedDuringCourse',
    );
    dispatchAddPageData(resetFullTimeEmployedDuringCoursePayload);

    const resetFullTimeJobPayload = payloadFactory.createResetPageDataPayload(
      'fullTimeJob',
      'fullTimeJob',
    );
    dispatchAddPageData(resetFullTimeJobPayload);

    dispatchWizardNav({ dir: 'fwd' });
  };

  const helpText =
    "If you're not employed right now it's not a problem. We'll then ask you a few questions about your most recent job.";
  return (
    <QuestionPageLayout
      id="currently-employed"
      value={initialCurrentlyEmployed}
      title="Are you currently employed?"
      onSubmit={handleSubmit}
      helpText={helpText}
    />
  );
};

CurrentlyEmployedPage.propTypes = {
  initialCurrentlyEmployed: PropTypes.bool,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

CurrentlyEmployedPage.defaultProps = {
  initialCurrentlyEmployed: null,
};

export const mapStateToProps = state => ({
  initialCurrentlyEmployed: state.builder.ui.currentlyEmployed,
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { CurrentlyEmployedPage };

export default connect(mapStateToProps, mapDispatchToProps)(CurrentlyEmployedPage);
